export type StateRequestBody = {
  /**
   * Mileage in km
   */
  mileage?: number | null;
  /**
   * Count of previous vehicle owners
   */
  ownerCount?: number | null;
  /**
   * Count of how many keys are passed on with the car
   */
  primaryKeyCount?: number | null;
  technicalInspectionValidUntil?: string | null;
  gasRevisionValidUntil?: string | null;
  pressureVesselValidUntil?: string | null;
  /**
   * Notes made on vehicle condition on latest inspection
   */
  technicalInspectionNote?: string | null;
  registrationPlate?: string | null;
  /**
   * Current vehicle condition
   */
  condition?: string | null;
  isAcceptableForTechnicalInspection?: boolean | null;
  /**
   * Is COC list provided for vehicle?
   */
  hasCoc?: boolean | null;
  /**
   * Real mileage in km
   */
  realMileage?: number | null;
  /**
   * Real mileage in km
   */
  vehicleRegistrationNumber?: string | null;
  /**
   * Real mileage in km
   */
  registrationCertificateNumber?: string | null;
  serviceBookType?: string | null;
  serviceBookState?: string | null;
  lastServiceDate?: string | null;
  /**
   * Last service mileage in km
   */
  lastServiceMileage?: number | null;
  nextServiceDate?: string | null;
  /**
   * Next service mileage in km
   */
  nextServiceMileage?: number | null;
  otherRecords?: string | null;
};
